(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4642],{

/***/ 4230:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[...param]",
      function () {
        return __webpack_require__(1060);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,5675,1175,7204,3065,8214,1151,3366,1874,9174,1847,9774,2888,179], function() { return __webpack_exec__(4230); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);